import { encryptPayload, normalizeEncryptedApiResponse } from './customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from './companySettingsCache';

export async function postGetPriceVariation(fullUrl, jwtToken, { draw, start, length, searchValue }) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const payload = { draw, start, length };
  if (searchValue !== undefined && searchValue !== null) {
    payload.search = { value: searchValue, regex: 'false' };
  }
  let body;
  if (useEncrypt) {
    const ep = encryptPayload(payload);
    if (!ep) {
      return {};
    }
    const fd = new FormData();
    fd.append('encrypted_payload', ep);
    body = fd;
  } else {
    const fd = new FormData();
    fd.append('draw', String(draw));
    fd.append('start', String(start));
    fd.append('length', String(length));
    if (payload.search) {
      fd.append('search[value]', String(payload.search.value ?? ''));
      fd.append('search[regex]', String(payload.search.regex ?? 'false'));
    }
    body = fd;
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}
